import { create } from 'zustand'

const initialState = {
  outcomeData: {
    ctg: {
      outcome_measures: []
    },
    eudract: {
      outcome_measures: []
    }
  }
}

const useResultsOutcomeStore = create((set) => ({
  ...initialState,
  setOutcomeData: (outcomeData) => set({ outcomeData }),
  resetResultsOutcomeStore: () => set(initialState),
}))

export {
  initialState
}

export default useResultsOutcomeStore;